module.exports = __webpack_public_path__ + "img/team-build.a1b1863c.svg";